"use client";

import ChatTableCard from "./ChatTableCard";
import ChatDetailCard from "./ChatDetailCard";
import ChatResultCard from "./ChatResultCard";
import ChatConfirmCard from "./ChatConfirmCard";
import ChatMapCard from "./ChatMapCard";
import ChatChartCard from "./ChatChartCard";
import type { RichContent } from "@/lib/caonabo/rich-content";

type Props = {
  content: RichContent;
  /** Para confirm cards. */
  onConfirm?: (toolName: string, pendingInput: Record<string, unknown>) => void;
  onCancel?: () => void;
};

/** Dispatcher que renderiza el rich content según su tipo. */
export default function ChatRichContent({ content, onConfirm, onCancel }: Props) {
  if (content.type === "table") return <ChatTableCard table={content} />;
  if (content.type === "detail") return <ChatDetailCard detail={content} />;
  if (content.type === "result") return <ChatResultCard result={content} />;
  if (content.type === "map") return <ChatMapCard map={content} />;
  if (content.type === "chart") return <ChatChartCard chart={content} />;
  if (content.type === "confirm") {
    return (
      <ChatConfirmCard
        confirm={content}
        onConfirm={onConfirm ?? (() => {})}
        onCancel={onCancel ?? (() => {})}
      />
    );
  }
  return null;
}
